/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsMicroServiceAuth
 */
export interface MelcoModelsMicroServiceAuth {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsMicroServiceAuth
     */
    apiKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsMicroServiceAuth
     */
    token?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsMicroServiceAuth
     */
    tempToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsMicroServiceAuth
     */
    impersonationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsMicroServiceAuth
     */
    accessToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsMicroServiceAuth
     */
    userCultureCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsMicroServiceAuth
     */
    assetToken?: string | null;
}

export function MelcoModelsMicroServiceAuthFromJSON(json: any): MelcoModelsMicroServiceAuth {
    return MelcoModelsMicroServiceAuthFromJSONTyped(json, false);
}

export function MelcoModelsMicroServiceAuthFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsMicroServiceAuth {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'apiKey': !exists(json, 'apiKey') ? undefined : json['apiKey'],
        'token': !exists(json, 'token') ? undefined : json['token'],
        'tempToken': !exists(json, 'tempToken') ? undefined : json['tempToken'],
        'impersonationId': !exists(json, 'impersonationId') ? undefined : json['impersonationId'],
        'accessToken': !exists(json, 'accessToken') ? undefined : json['accessToken'],
        'userCultureCode': !exists(json, 'userCultureCode') ? undefined : json['userCultureCode'],
        'assetToken': !exists(json, 'assetToken') ? undefined : json['assetToken'],
    };
}

export function MelcoModelsMicroServiceAuthToJSON(value?: MelcoModelsMicroServiceAuth | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'apiKey': value.apiKey,
        'token': value.token,
        'tempToken': value.tempToken,
        'impersonationId': value.impersonationId,
        'accessToken': value.accessToken,
        'userCultureCode': value.userCultureCode,
        'assetToken': value.assetToken,
    };
}


